import { get } from '@webapp-next/lib/request/webapp/apiv2';

export default async function getPayRates(employeeId) {
  try {
    const url = `api/v2/area-rates/${employeeId}`;
    const { data } = await get(url);
    return data || [];
  } catch (error) {
    console.error('runRules failed', error);
  }
}

window.getPayRates = getPayRates;
